export default __webpack_public_path__ + "static/media/initial_screen.4b7e079c.png";